// Copyright (c) 2016 Deere & Company

import MaintenancePlan from '../../../reports/maintenance-plan/state-connector';

export default {
    component: MaintenancePlan,
    name: 'MAINTENANCE_PLAN',
    path: 'maintenance-plan'
};




// WEBPACK FOOTER //
// ./src/routes/products/reports/maintenance-plan.js